import { dataActionTypes } from "src/action_types";
import { loadStates } from "src/constants/load_states";

const defaultState = {
  loadState: loadStates.ready
};

export function resetPasswordReducer(state = defaultState, action) {
  switch (action.type) {
    case dataActionTypes.resetPasswordLoading:
      return { loadState: loadStates.loading };
    case dataActionTypes.resetPasswordReady:
      return { loadState: loadStates.ready };
    default:
      return state;
  }
}
